<template>
  <path
    class="fil0"
    d="M88 159c-12,-21 11,-35 20,-43 14,-13 20,-33 0,-63 -22,-33 -38,-42 -70,-8 -82,114 119,330 239,257 36,-30 28,-47 -3,-71 -28,-22 -48,-18 -62,-4 -9,8 -25,30 -45,17 -29,-19 -62,-55 -79,-85zm227 14c-1,13 -21,13 -20,-1 1,-73 -54,-132 -127,-135 -13,-1 -12,-21 1,-20 85,4 147,71 146,156zm-102 -4c0,14 -19,14 -20,1 -1,-20 -9,-29 -30,-32 -13,-1 -11,-21 2,-20 31,4 47,21 48,51zm51 1c1,13 -19,14 -20,1 -2,-51 -28,-78 -78,-84 -13,-1 -11,-21 2,-20 60,7 94,43 96,103z" />
</template>

<script>
export default {
  name: 'IconPhoneCall',
}
</script>

